import PendoTable from '../../../components/table/pendo-table.vue.js';
import get from 'lodash/get.js';
import keyBy from 'lodash/keyBy.js';

const pollTypeLabels = {
  PickList: 'Multiple Choice',
  PositiveNegative: 'Yes / No',
  FreeForm: 'Open Text Field',
  NumberScale: 'Number Scale',
  NPSRating: 'NPS Survey',
  NPSReason: 'NPS Reason'
};
const pollNotFoundLabel = 'Not Found';
var script = {
  name: 'PendoPollMetricsTable',
  components: {
    PendoTable
  },
  props: {
    sortConfig: {
      type: Object,
      default: () => ({
        prop: 'question',
        order: 'none'
      })
    },
    guide: {
      type: Object,
      required: true
    },
    polls: {
      type: Array,
      default: null
    },
    views: {
      type: Array,
      default: null
    },
    viewsAggStatus: {
      type: String,
      required: true
    },
    responseCount: {
      type: Array,
      default: null
    },
    responseCountAggStatus: {
      type: String,
      required: true
    },
    hrefFunction: {
      type: Function,
      default: null
    },
    maxHeight: {
      type: Number,
      default: 600
    }
  },
  data() {
    return {
      columns: [{
        prop: 'question',
        label: 'Question',
        minWidth: 260,
        sortable: true,
        type: 'link',
        href: this.hrefFunction
      }, {
        prop: 'type',
        label: 'Type',
        width: 180,
        sortable: true,
        formatter: _ref => {
          let {
            type
          } = _ref;
          return pollTypeLabels[type];
        }
      }, {
        prop: 'views',
        label: 'Views',
        async: true,
        sortable: true
      }, {
        prop: 'responseCount',
        label: 'Responses',
        async: true,
        sortable: true
      }, {
        prop: 'stepNumber',
        label: 'Poll Step',
        sortable: true
      }]
    };
  },
  computed: {
    pollsData() {
      const polls = this.polls || this.guide.polls;
      const responseCountByPollId = keyBy(this.responseCount, 'pollId');
      const viewsByStepId = keyBy(this.views, 'guideStepId');
      return polls.map(poll => {
        const {
          id,
          question,
          attributes: {
            type
          }
        } = poll;
        const responseCount = this.responseCountAggStatus === 'resolved' ? get(responseCountByPollId[id], 'count', 0) : null;
        const pollStepId = this.getPollStepId(id);
        let views;
        if (!pollStepId) {
          views = pollNotFoundLabel;
        } else {
          views = this.viewsAggStatus === 'resolved' ? get(viewsByStepId[pollStepId], 'count', 0) : null;
        }
        return {
          id,
          question,
          type,
          views,
          responseCount,
          stepNumber: this.getStepNumber(pollStepId)
        };
      });
    }
  },
  methods: {
    onLinkClick(_ref2) {
      let {
        row
      } = _ref2;
      this.$emit('poll-link-click', row);
    },
    getStepNumber(stepId) {
      if (!stepId) {
        return pollNotFoundLabel;
      }
      return this.guide.steps.findIndex(step => step.id === stepId) + 1;
    },
    getPollStepId(pollId) {
      const pollStep = this.guide.steps.find(step => {
        return step.pollIds && step.pollIds.includes(pollId);
      });
      return get(pollStep, 'id');
    }
  }
};

export { script as default };
//# sourceMappingURL=pendo-poll-metrics-table.vue2.js.map
